import { render } from "./OrganLogin.vue?vue&type=template&id=87ceae72&scoped=true"
import script from "./OrganLogin.vue?vue&type=script&lang=js"
export * from "./OrganLogin.vue?vue&type=script&lang=js"

import "./OrganLogin.vue?vue&type=style&index=0&id=87ceae72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ceae72"]])

export default __exports__